var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, runInAction } from 'mobx';
import { ModelMediaCategory } from '~/models/model.media-category';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { UIOpenService } from '~/services/service.ui';
import { ESortingOption } from '~/shared/types';
export let ServiceMediaCategories = class ServiceMediaCategories extends BaseSingletonService {
    openDialogSvc;
    categories = [];
    sorting = ESortingOption.default;
    categoryId;
    communityId;
    constructor(openDialogSvc) {
        super();
        this.openDialogSvc = openDialogSvc;
        makeObservable(this);
    }
    setCategoryId(categoryId) {
        this.categoryId = categoryId;
    }
    setCommunityId(communityId) {
        this.communityId = communityId;
    }
    setSorting(sorting) {
        this.sorting = sorting;
    }
    getItems(items) {
        return items?.map(item => ({
            title: item.name,
            id: item.id,
            hasChildren: Number.parseFloat(item.childCount) > 0,
            hasTags: Number.parseFloat(item.tagsCount) > 0,
        }));
    }
    getCategories(sorting) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityId}/categories/${this.categoryId}/${EApiUrl.children}`, {
                params: {
                    sort: sorting ?? this.sorting,
                },
            })
                .then(response => {
                runInAction(() => (this.categories = this.getItems(plainToInstance(ModelMediaCategory, response.data?.collection))));
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], ServiceMediaCategories.prototype, "categories", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof ESortingOption !== "undefined" && ESortingOption) === "function" ? _b : Object)
], ServiceMediaCategories.prototype, "sorting", void 0);
ServiceMediaCategories = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceMediaCategories);
